import { useEffect } from "react";
import { useState } from "react";
import { Breadcrumb, Image } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRetailerVatSettings, refreshRetailerSettings } from "../../utils/vatHelper";

import {
  deleteCartListApi,
  deleteaLLCartListApi,
  editCartApi,
  geCartListApi,
} from "../../Features/AddCart/AddCart";
import { routes } from "../../Routes/Routes";
import { setCartCount } from "../../Features/User/User";
import { getVariantTags } from "../../utils/cartVariants";
import { slugify } from "../../utils/categoryUrl";

import styles from "./index.module.scss";

function Shopping() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState();

  const userToken = useSelector((state) => state.user?.token);
  const cartCounter = useSelector((state) => state.user?.cartCount);
  const cartlist = useSelector((state) => state.addCart?.cartListData);
  const loader = useSelector((state) => state.addCart?.isAddCartLoad);
  const [vatSettings, setVatSettings] = useState(getRetailerVatSettings());

  const isContinueButtonDisabled = cartlist?.cartItems?.some(
    (item) =>
      item?.Quantity > item?.Stock || item?.Quantity <= 0 || item?.outOfStock,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(geCartListApi(userToken));
    refreshRetailerSettings().then(() => setVatSettings(getRetailerVatSettings()));
  }, [dispatch, userToken]);

  const Incree = (item) => {
    const updatedQuantity = item?.Quantity + 1;
    const obj = { Quantity: updatedQuantity };
    const onSuccessCallback = () => {
      dispatch(geCartListApi(userToken));
      setData(updatedQuantity);
    };
    dispatch(editCartApi(obj, userToken, item?._id, onSuccessCallback));
  };

  const Decree = (item) => {
    const updatedQuantity = item?.Quantity - 1;
    const obj = { Quantity: updatedQuantity };
    const onSuccessCallback = () => {
      dispatch(geCartListApi(userToken));
      setData(updatedQuantity);
      if (updatedQuantity === 0) {
        dispatch(deleteCartListApi(item?._id, userToken));
      }
    };
    setData(data - 1);
    dispatch(editCartApi(obj, userToken, item?._id, onSuccessCallback));
  };

  const removeCartItem = (item) => {
    if (cartCounter > 0) {
      dispatch(setCartCount(cartCounter - 1));
    }
    dispatch(deleteCartListApi(item?._id, userToken));
  };

  const clearCart = () => {
    dispatch(deleteaLLCartListApi(userToken));
    dispatch(setCartCount(0));
  };

  const formatPrice = (price) => {
    return Number(price || 0).toLocaleString("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const cartItems = cartlist?.cartItems || [];
  const itemCount = cartItems.length;

  return (
    <div className={styles.page}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumbBar}>
        <div className={styles.breadcrumbInner}>
          <Breadcrumb
            className={styles.breadcrumb}
            items={[
              { title: <Link to="/">Home</Link> },
              { title: "Cart" },
            ]}
          />
        </div>
      </div>

      {/* Page Title */}
      <div className={styles.pageTitle}>
        <span className={styles.titleEyebrow}>The Diamond Counter</span>
        <h1 className={styles.titleText}>Shopping Cart</h1>
        <div className={styles.titleLine} />
      </div>

      {itemCount > 0 ? (
        <div className={styles.container}>
          <div className={styles.cartLayout}>

            {/* LEFT: Cart Items */}
            <div className={styles.cartItems}>
              <div className={styles.cartHeader}>
                <span className={styles.itemCount}>
                  <strong>{itemCount}</strong> {itemCount === 1 ? "item" : "items"} in your cart
                </span>
                <button
                  type="button"
                  className={styles.clearBtn}
                  onClick={clearCart}
                >
                  Clear All
                </button>
              </div>

              {cartItems.map((item, index) => (
                <div key={item?._id || index} className={styles.cartCard}>
                  <div
                    className={styles.cartCardImage}
                    onClick={() =>
                      navigate(`/product-detail/${item?.Product?.product_Name}`, {
                        state: { productId: item?.Product?._id },
                      })
                    }
                  >
                    <Image
                      preview={false}
                      src={item?.Variation?.image}
                      alt={item?.Product?.product_Name}
                      className={styles.cartImg}
                    />
                  </div>

                  <div className={styles.cartCardInfo}>
                    <div className={styles.cartCardTop}>
                      <div>
                        <h4
                          className={styles.cartProductName}
                          onClick={() =>
                            navigate(`/product-detail/${slugify(item?.Product?.product_Name)}`, {
                              state: { productId: item?.Product?._id },
                            })
                          }
                        >
                          {item?.Product?.product_Name}
                        </h4>
                        <div className={styles.cartVariants}>
                          {getVariantTags(item).map(([label, value]) => (
                            <span key={label} className={styles.variantTag}>{label}: {value}</span>
                          ))}
                        </div>
                      </div>
                      <button
                        type="button"
                        className={styles.removeBtn}
                        onClick={() => removeCartItem(item)}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="18" y1="6" x2="6" y2="18" />
                          <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                      </button>
                    </div>

                    <div className={styles.cartCardBottom}>
                      <div className={styles.unitPrice}>
                        <span className={styles.priceLabel}>Unit Price</span>
                        <span className={styles.priceValue}>{"\u00A3"}{formatPrice(item?.price)}</span>
                      </div>

                      <div className={styles.qtyControl}>
                        <button type="button" onClick={() => Decree(item)}>-</button>
                        <span>{item?.Quantity}</span>
                        <button
                          type="button"
                          onClick={() => Incree(item)}
                          disabled={item?.Quantity >= item?.Stock}
                        >
                          +
                        </button>
                      </div>

                      <div className={styles.lineTotal}>
                        <span className={styles.priceLabel}>Total</span>
                        <span className={styles.priceValue}>{"\u00A3"}{formatPrice(item?.total)}</span>
                      </div>
                    </div>

                    {item?.outOfStock && (
                      <div className={styles.stockWarning}>Out of stock</div>
                    )}
                    {item?.Quantity > item?.Stock && !item?.outOfStock && (
                      <div className={styles.stockWarning}>
                        Only {item?.Stock} available
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <div className={styles.continueRow}>
                <button
                  type="button"
                  className={styles.continueLink}
                  onClick={() => navigate("/product/all")}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                  Continue Shopping
                </button>
              </div>
            </div>

            {/* RIGHT: Order Summary */}
            <div className={styles.summaryColumn}>
              <div className={styles.summaryCard}>
                <h3 className={styles.summaryTitle}>Order Summary</h3>

                <div className={styles.summaryRow}>
                  <span>Subtotal ({itemCount} {itemCount === 1 ? "item" : "items"})</span>
                  <span>{"\u00A3"}{formatPrice(cartlist?.totalOriginalAmount)}</span>
                </div>

                <div className={styles.summaryRow}>
                  <span>Shipping</span>
                  <span>
                    {Number(cartlist?.ShippingCharge) > 0
                      ? `\u00A3${formatPrice(cartlist?.ShippingCharge)}`
                      : "Free"}
                  </span>
                </div>

                {vatSettings.isVatRegistered ? (() => {
                  const vatAmount = Number(cartlist?.totalAmount || 0) * (vatSettings.vatRate / 100);
                  return (
                    <>
                      <div className={styles.summaryDivider} />
                      <div className={styles.summaryRow}>
                        <span>Subtotal (ex. VAT)</span>
                        <span>{"\u00A3"}{formatPrice(cartlist?.totalAmount)}</span>
                      </div>
                      <div className={styles.summaryRow}>
                        <span>VAT ({vatSettings.vatRate}%)</span>
                        <span>{"\u00A3"}{formatPrice(vatAmount)}</span>
                      </div>
                      <div className={styles.summaryDivider} />
                      <div className={`${styles.summaryRow} ${styles.summaryTotal}`}>
                        <span>Total (inc. VAT)</span>
                        <span>{"\u00A3"}{formatPrice(Number(cartlist?.totalAmount || 0) + vatAmount)}</span>
                      </div>
                    </>
                  );
                })() : (
                  <>
                    <div className={styles.summaryDivider} />
                    <div className={`${styles.summaryRow} ${styles.summaryTotal}`}>
                      <span>Total</span>
                      <span>{"\u00A3"}{formatPrice(cartlist?.totalAmount)}</span>
                    </div>
                  </>
                )}

                <button
                  type="button"
                  className={styles.checkoutBtn}
                  onClick={() => navigate(routes.summeryUrl)}
                  disabled={isContinueButtonDisabled || loader}
                >
                  {loader ? "Processing..." : "Proceed to Checkout"}
                </button>

                <div className={styles.trustSignals}>
                  <div className={styles.trustItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                    <span>Secure Checkout</span>
                  </div>
                  <div className={styles.trustItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="1" y="3" width="15" height="13" />
                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                      <circle cx="5.5" cy="18.5" r="2.5" />
                      <circle cx="18.5" cy="18.5" r="2.5" />
                    </svg>
                    <span>Insured Shipping</span>
                  </div>
                  <div className={styles.trustItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="1 4 1 10 7 10" />
                      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                    </svg>
                    <span>14-Day Returns</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
            </div>
            <h2 className={styles.emptyTitle}>Your Cart Is Empty</h2>
            <p className={styles.emptyDesc}>
              Discover our collection of luxury jewellery and add your favourite pieces.
            </p>
            <button
              type="button"
              className={styles.emptyBtn}
              onClick={() => navigate("/product/all")}
            >
              Explore Collection
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Shopping;
